import Routes from '../../constants/routes';
import makeUrl from './make-url';
import withInternalPath from './with-internal-path';

const getMaterialLink = (item: Material | DownloadableMaterial, internalPath?: string) =>
    withInternalPath(makeUrl(Routes.MATERIAL.pathByWorld(item.world), { id: item.id, slug: item.slug }), internalPath);

export default getMaterialLink;
